import { Text } from '@/components/ui/Text';
import dayjs from 'dayjs';
import Link from 'next/link';
import React from 'react';
import { TBlogArticleItemized } from '../../blog/blog.types';
import { BlogArticleCardImage } from '../BlogArticleCardImage';
import { BlogArticleReadMoreLink } from '../BlogArticleReadMoreLink';

import './BlogArticleCard.scss';

type Props = {
  article: TBlogArticleItemized;
};

export const BlogArticleCard: React.FC<Props> = ({ article: { item } }) => {
  const href = `/blog/${item.articleSlug}`;

  return (
    <article className='BlogArticleCard pb-3'>
      <Link href={href}>
        <div className='BlogArticleCard__main-image-container'>
          <BlogArticleCardImage
            className='BlogArticleCard__main-image'
            data={item.articleImage}
          />
        </div>

        <div className='BlogArticleCard__presentation px-8'>
          <Text className='BlogArticleCard__tag' variant='body' bold>
            {item.tag}
          </Text>

          <Text className='BlogArticleCard__title' variant='h3'>
            {item.title}
          </Text>
        </div>

        <div className='BlogArticleCard__text-box px-8'>
          <Text className='BlogArticleCard__content' variant='body'>
            {item.cardContent}
          </Text>

          <div className='BlogArticleCard__signature flex gap-1'>
            <Text variant='body-small'>{`${item.author.firstName} ${item.author.lastName}`}</Text>

            <svg width='3' height='3' viewBox='0 0 3 3' fill='none'>
              <path
                d='M2.79996 2.768H-3.89814e-05V-4.29153e-06H2.79996V2.768Z'
                fill='#6B6B6B'
              />
            </svg>

            <Text variant='body-small'>
              {dayjs(item.dateUpdated).format('MMM d, YYYY')}
            </Text>
          </div>
        </div>
      </Link>

      <div className='BlogArticleCard__url px-8'>
        <BlogArticleReadMoreLink redirectUrl={href} />
      </div>
    </article>
  );
};
